//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	getListByCode
} from '@/common/js/dictionary.js'
import {
	getDateDiff
} from '@/common/js/util.js'
const audio = uni.createInnerAudioContext()
var time
export default {
	data() {
		return {
			mySoundWallList: [], // 列表
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
				finished: false
			},
			prevIndex: 0,
			titList: [],
			activeLine: 'mm_access', // tab下划线的位置
			state: 'mm_access', // 当前tab选项
			imgList: []
		}
	},
	async onLoad() {
		this.titList = await getListByCode('mm_state')
		this.queryData()
	},
	onReachBottom() {
		if (this.mySoundWallList.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		chatSum(num) {
			if (num > 999 && num < 99999) {
				num = parseInt(num / 1000) + 'k'
			} else if (num > 99999) {
				num = parseInt(num / 10000) + 'w'
			}
			return num
		},
		handleClick(item) {
			uni.navigateTo({
				url: `/pages/strategy/detail?item=${item.id}`
			})
		},
		preview(t, i) {
			this.imgList = t.map(res => {
				return this.$getImg(res)
			})
			uni.previewImage({
				current: i,
				urls: this.imgList,
				indicator: 'default'
			})
		},
		// tab列表选择
		active(val) {
			this.state = val.code
			this.mySoundWallList = []
			this.page.currentPage = 1
			this.queryData()
			this.activeLine = val.code
		},
		// 列表获取
		queryData() {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/share/queryByState',
				data: {
					...this.page,
					memberId: this.$store.state.userInfo.memberId,
					state: this.state
				}
			}).then(res => {
				this.page.count = res.count
				if (res.data) {
					let list = res.data.map(t => {
						return {
							...t,
							createTime: getDateDiff(t.createTime),
							voice: 'static',
							images: t.images ? t.images.split(',') : [],
							nickName: decodeURI(t.nickName),
							content: decodeURI(t.content)
						}
					})
					this.mySoundWallList.push.apply(this.mySoundWallList, list)
				}
				if (this.mySoundWallList.length >= this.page.count) {
					this.page.finished = true
				} else {
					this.page.finished = false
				}
				this.page.loading = false
			})
		},
		delData(item) {
			let _this = this
			uni.showModal({
				content: '确定要删除这条到此一游吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/cms/share/delete',
							data: {
								id: item.id
							}
						}).then(res => {
							_this.mySoundWallList = []
							_this.page.currentPage = 1
							_this.queryData()
						})
					} else if (res.cancel) {

					}
				}
			})
		},
		//语音播放
		playSounds(t, index) {
			if (audio.src != this.$getImg(t.mediaUrl)) {
				this.mySoundWallList[this.prevIndex].voice = 'static'
				audio.src = this.$getImg(t.mediaUrl)
				this.prevIndex = index
			}
			if (t.voice == 'static') {
				t.voice = 'dynamic'
				audio.play()
				time = setTimeout(() => {
					this.mySoundWallList[index].voice = 'static'
				}, t.mediaLen * 1000)
			} else {
				t.voice = 'static'
				audio.pause()
			}

		},
	}
}
